<template>
  <div id="container" ref="mapRef" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <div class="containerBg">  
      <div class="topContent">
        <div class="dh_wz">
          <div class="dh_wz_qq">
            <div class="dh_wz_tb"></div>
          </div>
          <div class="dh_wz_wz">上蔡县</div>
        </div>
        <div class="dh_lb">
          <router-link :to="{path:'/gbzntyj'}"><div class="dh_lb_bt">项目总览</div></router-link>
          <router-link :to="{path:'/zuowufenxi'}"><div class="dh_lb_bt dh_lb_bt_cur">农作物分析</div></router-link>
          <router-link :to="{path:'/zhinengGG'}"><div class="dh_lb_bt">智能灌溉</div></router-link>
          <router-link :to="{path:'/binghai'}"><div class="dh_lb_bt">病虫害管理</div></router-link>
          <router-link :to="{path:'/plantmoxing'}"><div class="dh_lb_bt">种植模型</div></router-link>
          <router-link :to="{path:'/wulianwang'}"><div class="dh_lb_bt">物联网监测</div></router-link>
          <router-link :to="{path:'/qihouYj'}"><div class="dh_lb_bt">气候灾害预警</div></router-link>
        </div>
        <div class="titleRightImg">
          <router-link :to="{ path: '/' }"
            ><img src="../assets/img/gbzntyj/sy.png" class="return"
          /></router-link>
          <img
            src="../assets/img/gbzntyj/fh.png"
            class="return"
            @click="clickReturn"
          />
        </div>
      </div>
      <div class="left_txt">
        <span style="color:#fff">农作物分析</span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";

// todo 项目使用请放开 leaflet 引入
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet/dist/leaflet.esm.js';
import Gep from "../utils/范围面.json";
import ldt from "../components/gbzntyj/ldt.vue";
import dczz from "../components/gbzntyj/dczz.vue";

export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();
    const mapRef = ref(null);
    const state = reactive({
      videoList:[
        {"options": {
        src: "https://open.ys7.com/v3/openlive/AY7450743_1_1.m3u8?expire=1740469358&id=684063127445118976&t=5e8f94eefbe121dda21fd8383223878723663d4ca8ab190ceaae69eadfc3b4ce&ev=100", //视频源
        type: "m3u8", //视频类型
        }},
        {"options": {
        src: "https://open.ys7.com/v3/openlive/AY7450743_2_1.m3u8?expire=1740469617&id=684064213664010240&t=572c6d494359c31e35a8f224ba9691ce8f956dea8a1a889e5483886a40009175&ev=100", //视频源
        type: "m3u8", //视频类型
        }},
        {"options": {
        src: "https://open.ys7.com/v3/openlive/AZ4145835_1_1.m3u8?expire=1740469690&id=684064520181043200&t=6699d6107d69eabc0956f6c5cf25d45c3845b6ee7b160da50f9d782832f47687&ev=100", //视频源
        type: "m3u8", //视频类型
        }},
        {"options": {
        src: "https://open.ys7.com/v3/openlive/AZ4145835_2_1.m3u8?expire=1740469738&id=684064718175588352&t=06d493a79c6a5df6688db39d30c49546b331f6609e1fbab6d8722388b29831ef&ev=100", //视频源
        type: "m3u8", //视频类型
        }}
      ],
      config: {
        // header: ['<span style="color:#038259;">网上名称</span>', '<span style="color:#038259;">归属地</span>', '<span style="color:#038259;">店铺数据</span>'],
        data: [
          ["1号地块", "120次", "88人", "100min"],
          ["2号地块", "170次", "88人", "100min"],
          ["3号地块", "150次", "88人", "100min"],
          ["4号地块", "220次", "88人", "100min"],
          ["5号地块", "620次", "88人", "100min"],
          ["6号地块", "420次", "88人", "100min"],
          ["7号地块", "520次", "88人", "100min"],
          ["8号地块", "320次", "88人", "100min"],
          ["9号地块", "720次", "88人", "100min"],
        ],
        headerBGC: "",
        oddRowBGC: "",
        evenRowBGC: "",
        // index: true,
        columnWidth: [150],
        align: ["center"],
        // rowNum:6
      },
    });

    const emit = defineEmits(["mapLoad"]);
    const boundaryData = Gep;
    console.log(boundaryData);

    const marker = ref();
    const map = ref(null);
    let current = ref(0);

    // 地图底图
    // 第一种
    let mapType = ref("vec");
    let mapLabelType = ref("cva");

    let mapType1 = ref(
      L.tileLayer(
        "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&x={x}&y={y}&z={z}",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );

    let mapLabelType1 = ref(
      L.tileLayer(
        "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    // let mapLabelType1 = ref(
    //   L.tileLayer(
    //     "https://t{s}.tianditu.gov.cn/" +
    //       "cva" +
    //       "_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=" +
    //       "cva" +
    //       "&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );

    const initMap = () => {
      map.value.addLayer(mapType1.value);
      map.value.addLayer(mapLabelType1.value);
      map.value.on("click", ({ latlng }) => {
        console.log("坐标：", Object.values(latlng));
      });

      return map.value;
    };

    const mapObj = ref();

    // 在 onMounted 中初始化地图
    onMounted(() => {
      map.value = L.map(mapRef.value, {
        center: [33.24715813736589, 114.12958145141602],

        // center: [114.182633, 33.240019],
        zoom: 13,
        minZoom: 3,
        maxZoom: 19,
        noWrap: true,
        // dragging: false,
        zoomControl: true,
        attributionControl: false,
      });
      mapObj.value = initMap();
      // createMarkers();
      loadBoundary();
    });

    function createDashedPolyline(feature, style) {
      const latLngs = feature.geometry.coordinates;
      if (feature.geometry.type === "Polygon") {
        // 取外圈线作为多段线处理
        latLngs = [latLngs[0]];
      } else if (feature.geometry.type === "MultiPolygon") {
        // 处理多个多边形，这里仅取第一个外圈线
        latLngs = [latLngs[0][0]];
      }

      const options = {
        ...style,
        dashArray: [5, 5], // 虚线长度与间距
        lineCap: "round", // 线头样式，可选
        lineJoin: "round", // 线交接处样式，可选
      };

      return L.polyline(latLngs, options);
    }

    // 添加行政区划边界的逻辑
    const loadBoundary = () => {
      L.geoJSON(boundaryData, {
        onEachFeature: function (feature, layer) {
          let style;

          switch (feature.properties.T) {
            case "未建成":
              style = {
                color: "green",
                fillColor: "green",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
              break;
            case "其他":
              style = {
                color: "blue",
                fillColor: "blue",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
              break;
            default:
              style = {
                color: "white",
                fillColor: "red",
                fillOpacity: 0.25,
                dashArray: [5, 5],
                weight: 1,
              };
          }

          if (
            feature.geometry.type === "Polygon" ||
            feature.geometry.type === "MultiPolygon"
          ) {
            // 设置填充样式
            layer.setStyle(style);

            // 处理每个外环线为虚线
            feature.geometry.coordinates.forEach((ring, index) => {
              if (index === 0 || feature.geometry.type === "Polygon") {
                // 对于多边形，只处理外环线
                const dashedLine = createDashedPolyline(
                  { geometry: { coordinates: [ring] } },
                  style
                );
                map.value.addLayer(dashedLine);
              }
            });
          } else if (
            feature.geometry.type === "LineString" ||
            feature.geometry.type === "MultiLineString"
          ) {
            const dashedLine = createDashedPolyline(feature, style);
            map.value.addLayer(dashedLine);
          }

          // 添加原始图层到地图上（用于显示填充区域）
          map.value.addLayer(layer);
        },
      }).addTo(map.value);
    };

    const removeMap = () => {
      if (mapObj.value) {
        mapObj.value.remove();
      }
    };

    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
    });
    onUnmounted(() => {
      removeMap();
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),
      mapRef,

      clickReturn,
    };
  },
  components: {
    ldt,
    dczz,
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
::v-deep .d-player-wrap .d-player-control{
  height: 30px;
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  .containerBg{
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../assets/img/gbzntyj/bg.png") no-repeat;
    z-index: 999;
  }


  .dh_wz {
    width: 140px;
    height: 47px;
    position: absolute;
    left: 3%;
    top: 20%;
    background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
    background-size: 100% 100%;

    .dh_wz_qq {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 7px;
      border: 1px solid #ffc600; /* 添加一个黑色的边框 */
      .dh_wz_tb {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 7px;
        top: 7px;
        background: url("../assets/img/gbzntyj/nt.png") no-repeat top center;
        background-size: 100% 100%;
      }
    }
    .dh_wz_wz {
      width: 120px;
      height: 47px;
      line-height: 47px;
      color: #fff;
      font-size: 17px;
      font-weight: 500;
      text-align: center;
      position: absolute;
      left: 21%;
      letter-spacing: 0.3em;
    }
  }
  .topContent {
    width: 100%;
    height: 100px;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 34, 25, 1) 20%,
      rgba(0, 34, 25, 0)
    );
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    .titleRightImg {
      position: absolute;
      right: 0;
      top: -27%;
      .return {
        width: 77px;
        height: 32px;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        z-index: 999;
      }
    }
  }

  .dh_lb {
    width: 900px;
    height: 45px;
    position: absolute;
    left: 23%;
    top: 20%;
    display: flex;
    flex-flow: row;
    a{
      text-decoration: none;
    }

    .dh_lb_bt {
      width: 124px;
      height: 43px;
      background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;
    }
    .dh_lb_bt:hover,.dh_lb_bt_cur {
      width: 124px;
      height: 43px;
      cursor: pointer;
      background: url("../assets/img/gbzntyj/xz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }
  .left_txt {
    width: 500px;
    height: 88%;
    position: absolute;
    top: 9%;
    left: 3%;
    display: flex;
    flex-direction: column;
    z-index: 999;
    
  }

}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

#video .d-player-wrap .d-player-control{
  height: 50px;
}
</style>
